import { FC, useMemo } from 'react'

import { clamp } from '../../utilities/clamp'

import { Star } from './Star'
import { StarRatingProps } from './types'

export const StarRating: FC<StarRatingProps> = ({
  maxStars = 5,
  stars,
  filledColor = '#111111',
  emptyColor = '#C8C8C8',
  ...props
}) => {
  const clampedStars = useMemo(
    () => clamp(stars, 0, maxStars),
    [stars, maxStars],
  )

  const maskPercentage = useMemo(() => (clampedStars % 1) * 100, [clampedStars])

  const partialStarIndex = useMemo(
    () => (clampedStars % 1 !== 0 ? Math.floor(clampedStars) : -1),
    [clampedStars],
  )

  return (
    <div
      className="relative flex items-start [&_svg]:text-[#C8C8C8]"
      role="img"
      aria-label={`${clampedStars} out of ${maxStars} stars`}
      {...props}
    >
      {Array(maxStars)
        .fill(0)
        .map((_, idx) => (
          <Star
            key={idx}
            {...(idx === partialStarIndex && { maskPercentage })}
            filledColor={filledColor}
            emptyColor={emptyColor}
            filled={idx < clampedStars}
            aria-hidden={idx >= clampedStars}
          />
        ))}
    </div>
  )
}
